export default __webpack_public_path__ + "static/media/keithmoji.65ea275b.png";